import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { HtmlTextService } from '../../services/html-text.service';
import { ModalService } from "../../utilities/modal/modal.service";
import { WindowRefService } from '../../services/window-ref.service';
@Component({
  selector: 'speed-bump',
  templateUrl: './speed-bump.component.html',
  styleUrls: ['./speed-bump.component.scss']
})
export class SpeedBumpComponent implements OnInit {
  @Input() definitionLocation: string;
  @Input() definitionID: string;
  @ViewChild("speedbump_button") speedbump_button: ElementRef;
  data: any;
  ctaTxt: string;
  ctaLink: string;
  speedbump: string;
  speedbumpCta: string;
  modalNum: number;
  modalId: string;
  crypto = window.crypto;
  constructor(
    private _htmlTextService: HtmlTextService,
    private modalService: ModalService,
  ) { }

  ngOnInit() {
    const serviceUrl = '/wps/wcm/myconnect/' + this.definitionLocation + '/' + this.definitionID;
    const crypto = this.crypto || window['msCrypto'];
    this.modalNum = crypto.getRandomValues(new Uint32Array(1))[0];
    this._htmlTextService.getHTMLText(serviceUrl).subscribe((serviceData) => {
      this.processData(serviceData)
    });
  }

  processData(inputdata) {
    if (inputdata) {
      try {
        let wcmdata = inputdata.replace(/(\r|\n|\t|\f)/g, "")
          .replace(/dir="ltr"/gi, "")
          .replace(/dir=\\"ltr\\"/gi, "")
          .replace(/dir="\\&quot;ltr\\&quot;"/gi, "")
          .replace(/[\u0000-\u0019]+/g, "");
        this.data = JSON.parse(wcmdata);
        this.modalId = this.data['modalId'] + this.modalNum;
      } catch (e) {
        console.warn("SpeedBump parsing error: ", e);
      }
    }
  }

  openModal() {
    this.modalService.open(this.modalId);
  }

  speedBumpCta() {
    this.modalService.close(this.modalId);
    this.focusOnDismiss();
  }

  onHidden($event) {
    if ($event) {
      this.focusOnDismiss();
    }
  }

  focusOnDismiss(){
    this.speedbump_button.nativeElement.focus();
  }
}
